import { InstrumentDefinitionWithId } from '@app/core/store/capital-structure-slice-selectors';
import CellValue from '@app/shared/components/cell-value/CellValue';
import { Toggle, ToggleSize } from '@app/shared/components/toggle/Toggle';
import { DividendInstrumentDto, DividendSetDto } from '@app/shared/models/contracts/project-dto';
import classNames from 'classnames';
import { FC } from 'react';
import HistoricCells from './HistoricCells';
import ForecastCells from './ForecastCells';

interface InstrumentRowProps {
  instrument: InstrumentDefinitionWithId;
  isEligible: boolean;
  adjustedNarrativeWidth: number;
  handleToggleChange: (id: string) => void;
  historicDividendInstruments: Record<string, DividendInstrumentDto>;
  forecastSet: DividendSetDto | undefined;
  forecastDates: string[];
  styles: { [key: string]: string };
  showHistoricColumns: boolean;
  instrumentCreationDates: { instrumentId: string; creationDate: string }[];
}

const InstrumentRow: FC<InstrumentRowProps> = ({
  instrument,
  isEligible,
  adjustedNarrativeWidth,
  handleToggleChange,
  historicDividendInstruments,
  forecastSet,
  forecastDates,
  styles,
  showHistoricColumns,
  instrumentCreationDates,
}) => (
  <tr key={instrument.instrumentId}>
    <th
      className={classNames(
        'table-primary__cell--vertical-separator',
        styles['instrument-narrative']
      )}>
      <div style={{ width: `${adjustedNarrativeWidth}px` }}>
        <CellValue value={instrument.instrumentNarrative} />
      </div>
      <Toggle
        name={`instrumentDefinitions[${instrument.instrumentId}].dividendEligible`}
        toggleSize={ToggleSize.Medium}
        onChange={() => handleToggleChange(instrument.instrumentId)}
      />
    </th>
    {showHistoricColumns && (
      <>
        <HistoricCells
          instrumentId={instrument.instrumentId}
          isEligible={isEligible}
          historicDividendInstruments={historicDividendInstruments}
          instrumentCreationDates={instrumentCreationDates}
        />
        <td className="table-primary--framed" />
      </>
    )}
    <ForecastCells
      instrumentId={instrument.instrumentId}
      forecastSet={forecastSet}
      isEligible={isEligible}
      forecastDates={forecastDates}
      instrumentCreationDates={instrumentCreationDates}
    />
    <td />
  </tr>
);

export default InstrumentRow;
